import React from 'react'
import { createBrowserRouter } from "react-router-dom";
import Layoute from '../components/Layoute';
import Main from '../components/Main';
import ChoosFood from '../components/ChoosFood';
import ShopCart from '../components/ShopCart';
import Location from '../components/Location';

export const routers = createBrowserRouter([
    {
        path: '/',
        element: <Layoute />,
        children: [
            {
                path:'/',
                element:<Main/>,
                index: true,
            },
            {
                path:'/chooseFood',
                element:<ChoosFood  />
            },
            {
                path:'/shopCart',
                element:<ShopCart/>
            },
            {
                path:'/location',
                element:<Location/>
            },
        ]
    },
    
])

